<template>
  <div v-loading="loading">
    <el-row :gutter="10" v-if="user.name === ''">
      <el-form :model="user"
               ref="VerifyUserForm"
               size="mini">
        <el-col :md="6">
          <el-form-item prop="dni"
                        :label="identity.name">
            <el-input v-model="user.dni"
                      :placeholder="identity.example"/>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item>
            <el-button  class="default"
                        :disabled="user.dni === ''"
                        :loading="verifyLoad"
                        @click="verifyDni">VERIFICAR DATOS</el-button>
            <el-button  class="flat"
                        @click="cancel">CANCELAR</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row :gutter="10" v-else>
      <el-col :md="6">
        <label class="el-form-item__label label-data">DATOS DESDE TRL</label>
        <div class="data-user-box">
          <p class="title">DNI</p>
          <p class="data-user">{{user.dni}}</p>
          <p class="title">NOMBRE</p>
          <p class="data-user">{{user.name}} {{user.lastName}}</p>
        </div>
      </el-col>
      <el-col :md="6">
        <el-form :model="user"
                 :rules="rules"
                 ref="VerifyUserForm"
                 size="mini">
          <el-form-item prop="enterpriseId"
                        label="Empresa">
            <el-select v-model="user.enterpriseId"
                       filterable
                       placeholder="Seleccione una opción"
                       no-data-text="Cargando...">
              <el-option  v-for="enterprise in enterprises"
                          :key="enterprise.id"
                          :label="enterprise.name"
                          :value="enterprise.id"/>
            </el-select>
          </el-form-item>
          <el-form-item prop="email"
                        label="Correo">
            <el-input v-model="user.email"
                      placeholder="correo@mail.com"/>
          </el-form-item>
          <el-form-item prop="newPassword"
                        label="Contraseña">
            <el-input v-model="user.newPassword"
                      autocomplete="off"
                      type="password"
                      placeholder="******"/>
          </el-form-item>
          <el-form-item prop="newPasswordConfirm"
                        label="Verificar contraseña">
            <el-input v-model="user.newPasswordConfirm"
                      autocomplete="off"
                      type="password"
                      placeholder="******"/>
          </el-form-item>
          <el-form-item>
            <el-button  class="default"
                        @click="verify">CREAR</el-button>
            <el-button  class="flat"
                        @click="cancel">CANCELAR</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { apiRequest } from '@/backend/vue-axios/axios';

export default {
  name: 'UserFormStep3',
  props: {
    accountTypeId: {
      type: Number,
      default: 0,
    },
    identity: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    const passCheck = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('Complete el campo'));
      } else if (value !== this.user.newPassword) {
        callback(new Error('Contraseñas no coinciden'));
      } else {
        callback();
      }
    };
    const emailCheck = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('Complete el campo'));
      } else if (!this.validEmail(value)) {
        callback(new Error('Formato incorrecto'));
      } else {
        callback();
      }
    };
    return {
      user: {
        dni: '', // pe: 42118733
        name: '',
        lastName: '',
        email: '',
        newPassword: '',
        newPasswordConfirm: '',
        enterpriseId: '',
        accountTypeId: '',
        isAvailable: false,
      },
      rules: {
        email: [{
          required: true,
          trigger: 'change',
          message: 'Complete el campo',
        }, { validator: emailCheck, trigger: 'blur' }],
        newPassword: [{
          required: true,
          trigger: 'change',
          message: 'Complete el campo',
        }],
        newPasswordConfirm: [{ validator: passCheck, trigger: 'blur' }],
        enterpriseId: [{
          required: true,
          trigger: 'change',
          message: 'Complete el campo',
        }],
      },
      verifyLoad: false,
      loading: false,
      enterprises: [],
    };
  },
  mounted() {
  },
  methods: {
    verify() {
      this.$refs.VerifyUserForm.validate((valid) => {
        if (valid) { this.$emit('send', this.getData()); }
        return valid;
      });
    },
    getData() {
      return {
        account_types_id: this.accountTypeId,
        active: true,
        email: this.user.email.toLowerCase(),
        enterprise_id: this.user.enterpriseId,
        last_name: this.user.lastName,
        name: this.user.name,
        password: this.user.newPassword,
        rut: this.user.dni,
        username: this.user.email.toLowerCase(),
      };
    },
    verifyDni() {
      if (this.identity.name === 'RUT') {
        const ident = this.user.dni.split('-');
        if (ident.length === 2) {
          this.getDriverData(ident[0], ident[1]);
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Rut no válido',
          });
        }
      } else {
        this.getDriverData(this.user.dni, '');
      }
    },
    getDriverData(dni, dniDv) {
      this.verifyLoad = true;
      apiRequest({
        module: 'crud',
        service: 'verify_driver_data',
        params: { dni, dniDv },
      }).then((response) => {
        this.user.name = response.data.name;
        this.user.lastName = response.data.lastName;
        this.enterprises = response.data.enterprises;
        this.$notify.success({
          title: 'verificación',
          message: 'datos obtenidos con éxito',
        });
      }).catch((e) => {
        this.$notify.error({
          title: 'Error',
          message: e.response.data.message,
        });
        this.verifyLoad = false;
      });
    },
    validEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    cancel() {
      this.loading = true;
      this.$emit('cancel');
    },
    formatAvailable(isAvailable) {
      return isAvailable ? 'Si' : 'No';
    },
  },
};
</script>

<style lang="scss" scoped>
  .label-data {
    width: 100%;
    padding: 9px 0;
    text-align: left;
  }
 .data-user-box {
   padding: 8px;
   display: grid;
   border-radius: 3px;
   text-align: center;
   border: 1px solid #dcdfe6;
   .title {
     font-weight: 900;
     margin-bottom: 2px;
   }
   .data-user {
     margin-top: 0;
     margin-bottom: 16px;
   }
 }
</style>
